import { Component } from '@angular/core';

@Component({
  selector: 'ssg-stale-dated-checks-info',
  templateUrl: './stale-dated-checks-info.component.html',
  styleUrls: ['./stale-dated-checks-info.component.less']
})
export class StaleDatedChecksInfoComponent {
  constructor() { }
}
